import type {IModalsStore} from "data/stores/modals/modals.store";
import type {IUserStore} from "data/stores/user/user.store";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {makeAutoObservable} from "mobx";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import {Bindings} from "data/constants/bindings";
import logo from "assets/img/cfl_small_white_logo.png";
import logoFr from "assets/img/cfl_small_white_logo_french.png";

export interface ICFLHeaderController extends ViewController {
	get isAuthorized(): boolean;

	get localeLogo(): string;
	get language(): string;
}

@injectable()
export class CFLHeaderController implements ICFLHeaderController {
	constructor(
		@inject(Bindings.UserStore) private _userStore: IUserStore,
		@inject(Bindings.ModalsStore) private _modalsStore: IModalsStore,
		@inject(Bindings.LocalizationStore) public i18n: ILocalizationStore
	) {
		makeAutoObservable(this);
	}

	get isAuthorized(): boolean {
		return this._userStore.isAuthorized;
	}

	get localeLogo(): string {
		const icons: Record<string, string> = {
			en: logo,
			fr: logoFr,
		};
		return icons[this.language] ?? "";
	}

	get language(): string {
		return this.i18n.languageOnly ?? "en";
	}

	dispose(): void {
		return;
	}

	init(): void {
		return;
	}
}
